<header class="header--{{ theme() }} pt-topbar header">
  <div class="container pt-5 pb-5 pt-xl-6 position-relative">
    <header class="row pb-md-5 pb-3 pb-lg-5 header__content align-items-center px-sm-3 px-lg-0">
      <div class="col-md-10 col-lg-12">
        @if (header()?.subtitle) {
          <strong class="fs-body-sm fw-normal d-inline-block mb-3 lh-1">{{ header()?.subtitle }}</strong>
        }
        @if (header()?.title) {
          <h1 class="h2">{{ header()?.title }}</h1>
        }
      </div>

      @if (header()?.intro; as text) {
        <div class="col-md-14 col-lg-12 d-flex justify-content-end flex-column">
          <div class="markdown-content" fstrDynamicContent [innerHTML]="text | resizeHtmlImages | stripEmbed: undefined | safe"></div>

          @if (header()?.button?.url || header()?.secondaryButton?.url) {
            <div class="d-flex flex-wrap mt-3 gap-1 header-actions">
              @if (header()?.button?.url) {
                <fstr-link [button]="header()?.button!" [cssClasses]="'button button--primary button--sm'"></fstr-link>
              }

              @if (header()?.secondaryButton?.url) {
                <fstr-link [button]="header()?.secondaryButton!" [cssClasses]="'button button--light button--sm'"></fstr-link>
              }
            </div>
          }
        </div>
      }
    </header>
  </div>
</header>
